export const DashboardComponentType = {
  CREATE_BOOKING: 'CREATE_BOOKING',
  INFO_PANEL: 'INFO_PANEL',
  INFO_CARD: 'INFO_CARD',
  COMPARISON_INFO_CARD: 'COMPARISON_INFO_CARD',
  PIE_CHART: 'PIE_CHART',
}

export const DashboardActionType = {
  CREATE_BOOKING: 'CREATE_BOOKING',
  REPORT_TRAVEL_EXPENDITURE: 'REPORT_TRAVEL_EXPENDITURE',
  REPORT_TRAVEL_EXPENDITURE_TAXI: 'REPORT_TRAVEL_EXPENDITURE_TAXI',
  REPORT_TRAVEL_EXPENDITURE_COACH: 'REPORT_TRAVEL_EXPENDITURE_COACH',
  REPORT_TRAVEL_EXPENDITURE_CHAUFFER: 'REPORT_TRAVEL_EXPENDITURE_CHAUFFER',
  REPORT_TRAVEL_EXPENDITURE_CAR_RENTAL: 'REPORT_TRAVEL_EXPENDITURE_CAR_RENTAL',
  REPORT_TRAVEL_EXPENDITURE_E_BIKE: 'REPORT_TRAVEL_EXPENDITURE_E_BIKE',
  REPORT_TRAVEL_EXPENDITURE_E_SCOOTER: 'REPORT_TRAVEL_EXPENDITURE_E_SCOOTER',
  REPORT_BOOKINGS_COUNT: 'REPORT_BOOKINGS_COUNT',
  REPORT_BOOKINGS_CO2_EMISSIONS: 'REPORT_BOOKINGS_CO2_EMISSIONS',
  REPORT_BOOKINGS_UNCONFIRMED: 'REPORT_BOOKINGS_UNCONFIRMED',
  REPORT_BOOKINGS_UNALLOCATED: 'REPORT_BOOKINGS_UNALLOCATED',
  REPORT_BOOKINGS_OVERDUE: 'REPORT_BOOKINGS_OVERDUE',
  REPORT_BUDGET: 'REPORT_BUDGET',
}

export const StateResourceType = {
  CLIENT: 'CLIENT',
}
